/**
 * @flow
 * @relayHash dedf21221696384d1d8d93770519fd7d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedJournalEntriesContainer_journalEntries$ref = any;
export type JournalEntrySortField = "CREATED_AT" | "ENTRY_DATE" | "ENTRY_NUMBER" | "SOURCE_TYPE" | "STATUS" | "UPDATED_AT";
export type JournalEntryStatus = "DRAFT" | "POSTED" | "VOIDED";
export type JournalSourceType = "INVENTORY_ADJUSTMENT" | "INVOICE" | "JOB" | "MANUAL" | "PAYMENT" | "SHIPMENT";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type SortDirection = "ASC" | "DESC";
export type JournalEntrySort = {|
  field: JournalEntrySortField,
  direction: SortDirection,
|};
export type JournalEntriesQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?JournalEntrySort,
  statuses?: ?$ReadOnlyArray<JournalEntryStatus>,
  sourceTypes?: ?$ReadOnlyArray<JournalSourceType>,
  startDate?: ?any,
  endDate?: ?any,
|};
export type JournalEntriesQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
  |},
  +$fragmentRefs: PaginatedJournalEntriesContainer_journalEntries$ref,
|};
export type JournalEntriesQuery = {|
  variables: JournalEntriesQueryVariables,
  response: JournalEntriesQueryResponse,
|};
*/


/*
query JournalEntriesQuery(
  $search: String
  $sortBy: JournalEntrySort
  $statuses: [JournalEntryStatus!]
  $sourceTypes: [JournalSourceType!]
  $startDate: Date
  $endDate: Date
) {
  ...PaginatedJournalEntriesContainer_journalEntries_1mbeBN
  viewer {
    id
    permissions
  }
}

fragment PaginatedJournalEntriesContainer_journalEntries_1mbeBN on Query {
  journalEntries(first: 30, search: $search, sortBy: $sortBy, statuses: $statuses, sourceTypes: $sourceTypes, startDate: $startDate, endDate: $endDate) {
    edges {
      cursor
      ...JournalEntriesTable_journalEntryEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment JournalEntriesTable_journalEntryEdges on JournalEntryEdge {
  node {
    id
    entryNumber
    entryDate
    memo
    sourceType
    status
    syncStatus
    postedAt
    voidedAt
    totalDebit
    totalCredit
    createdByUser {
      id
      firstName
      lastName
    }
    createdAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "JournalEntrySort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "statuses",
    "type": "[JournalEntryStatus!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceTypes",
    "type": "[JournalSourceType!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "endDate",
    "type": "Date",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    }
  ]
},
v3 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v4 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v5 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v6 = {
  "kind": "Variable",
  "name": "sourceTypes",
  "variableName": "sourceTypes"
},
v7 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v8 = {
  "kind": "Variable",
  "name": "statuses",
  "variableName": "statuses"
},
v9 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "JournalEntriesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      (v2/*: any*/),
      {
        "kind": "FragmentSpread",
        "name": "PaginatedJournalEntriesContainer_journalEntries",
        "args": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "JournalEntriesQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "journalEntries",
        "storageKey": null,
        "args": (v9/*: any*/),
        "concreteType": "JournalEntryConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "JournalEntryEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "JournalEntry",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "entryNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "entryDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "memo",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sourceType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "syncStatus",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "postedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "voidedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalDebit",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalCredit",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "createdByUser",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "journalEntries",
        "args": (v9/*: any*/),
        "handle": "connection",
        "key": "PaginatedJournalEntriesContainer_journalEntries",
        "filters": []
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "JournalEntriesQuery",
    "id": null,
    "text": "query JournalEntriesQuery(\n  $search: String\n  $sortBy: JournalEntrySort\n  $statuses: [JournalEntryStatus!]\n  $sourceTypes: [JournalSourceType!]\n  $startDate: Date\n  $endDate: Date\n) {\n  ...PaginatedJournalEntriesContainer_journalEntries_1mbeBN\n  viewer {\n    id\n    permissions\n  }\n}\n\nfragment PaginatedJournalEntriesContainer_journalEntries_1mbeBN on Query {\n  journalEntries(first: 30, search: $search, sortBy: $sortBy, statuses: $statuses, sourceTypes: $sourceTypes, startDate: $startDate, endDate: $endDate) {\n    edges {\n      cursor\n      ...JournalEntriesTable_journalEntryEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JournalEntriesTable_journalEntryEdges on JournalEntryEdge {\n  node {\n    id\n    entryNumber\n    entryDate\n    memo\n    sourceType\n    status\n    syncStatus\n    postedAt\n    voidedAt\n    totalDebit\n    totalCredit\n    createdByUser {\n      id\n      firstName\n      lastName\n    }\n    createdAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '93d4e06d979969bcd3a10849d5b7f7e1';
module.exports = node;
